<dw-dynamic-routing-init></dw-dynamic-routing-init>

<div class="streakers-startup" *ngIf="showSlashScreen" role="status" aria-live="polite">
    <div class="streakers-startup-content">
        <img src="assets/img/streakers/streakers-loading-2026.webp" width="720" height="480" alt="" fetchpriority="high">
        <h1>Get Ready to Streak!</h1>
        <p>We’re getting things ready for you.</p>
        <span class="streakers-startup-progress" aria-hidden="true"></span>
    </div>
</div>
<div [hidden]="showSlashScreen">
    <!-- One NgIf owns both shells: destroy the old primary outlet before
         registering the new one, including when returning from admin. -->
    <ng-container *ngIf="showLayout">
    <dw-layout class="fitness-cap-shell" *ngIf="isAdminLayout; else participantLayout" [bodyClasses]="themeClasses" [showLogoutMessage]="true" [showLogoutMessageDialog]="true">
        <div breadcrumb>

        </div>
        <div topMenu>
            <div class="app-title">
                <div class="alert alert-warning env-message" [hidden]="!environmentMessage">
                    {{environmentMessage}}
                </div>
            </div>
        </div>
        <div sideBarTop>
            <div class="breadcrumb-container" style="margin-bottom:0px">
            </div>
        </div>
    </dw-layout>
    <ng-template #participantLayout>
        <streakers-layout [bodyClasses]="themeClasses" [environmentMessage]="environmentMessage"
            [showLogoutMessage]="true" [showLogoutMessageDialog]="true"></streakers-layout>
    </ng-template>
    </ng-container>
</div>
